import axios from 'axios';
import { PLATFORM_ID, CHECKOUT_URL } from '~/globalVariables';

export default async function checkout(cartId: string, authToken: string) {
  const res = await axios({
    method: 'post',
    url: `${CHECKOUT_URL}/${PLATFORM_ID}`,
    data: {
      cartId,
    },
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return res.data;
}
